const defaultData = (state = [], action) => {
    switch (action.type) {
        case 'GET_DEFAULT':
            return action.data;
        default:
            return state;
    }
};

export default defaultData;


// WEBPACK FOOTER //
// ./src/scripts/reducers/default.js